{
  "requestListPage": {
    "title": "Change requests",
    "table": {
      "name": "Name",
      "creator": "Request's author",
      "created_time": "Created time",
      "description": "Description",
      "status": "Status",
      "approved": "Approved",
      "approved_login": "Checker",
      "approvedYes": "Yes",
      "approvedNo": "No",
      "action": "Action",
      "approve_user": "Approve user"
    },
    "tabs": {
      "info": "Info",
      "changes": "Changes",
      "status": "Status"
    },
    "requestType": {
      "create_ci": "Create CI",
      "update_ci": "Change CI",
      "remove_ci": "Remove CI",
      "unknown": "Unknown action"
    },
    "createRequest": "Create request",
    "editRequest": "Edit request",
    "withoutChanges": "No changes",
    "changes": "Changes",
    "approve": {
      "approve": "Approve",
      "revoke": "Revoke"
    },
    "status": {
      "created": "Created",
      "progress": "In progress",
      "complete": "Complete"
    },
    "statusInfo": {
      "waiting": "Waiting",
      "in_progress": "In progress",
      "executed": "Executed",
      "failed": "Failed",
      "cancelled": "Canceled",
      "rollback_waiting": "Rollback waiting",
      "rollback_in_progress": "Rollback in progress",
      "rollback_executed": "Rollback executed",
      "rollback_failed": "Rollback failed"
    }
  }
}